import * as React from "react";
import { cn } from "../../lib/utils";

interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
	variant?: "default" | "success" | "destructive" | "muted";
}

export function Badge({ className, variant = "default", ...props }: BadgeProps) {
	return (
		<span
			className={cn(
				"inline-flex items-center px-2 py-0.5 text-xs font-mono border",
				{
					default: "border-[#00ffcc33] text-[#00ffcc]",
					success: "border-green-700 text-green-400",
					destructive: "border-red-700 text-red-400",
					muted: "border-[#1b4d43] text-[#8dbdb3]",
				}[variant],
				className,
			)}
			{...props}
		/>
	);
}
